import { LOGIN_USER, REGISTER_USER } from "../actions/userAction";


const default_user_info = {
    nombre: '',
    email: '',
    phone: '',
    password: '',
    id: null,
    avatar: '',
}
 
const userReducer = (state = default_user_info, action) => {
    switch (action.type) {
        case LOGIN_USER: {
            return {
                nombre: action.info.nameUser,
                email: action.info.email,
                phone: action.info.telephone,
                password: action.info.pass,
                id: action.info.userID,
                avatar: action.info.avatar
            }
        }
        case REGISTER_USER: {
            return {
                nombre: action.info[0],
                email: action.info[1],
                phone: action.info[2],
                password: action.info[3],
            }
        }

    
        default: return state;
    }
}

export default userReducer